import { Injectable } from '@angular/core';
import constantURL from '../../../shared/constantURL';
import { BaseLoggedInPostService } from '../../../shared/services/base-logged-in-post.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentOptionsService extends BaseLoggedInPostService {
  _path = constantURL.PaymentOptions.getAll;

  productAllowedOptions = new BehaviorSubject([]);

  async _make() {
    const data = (await super._make()) as unknown as { id:number, name: string; nameAr: string, enabledDirectPay: boolean }[];
    this.productAllowedOptions.next(data?.length ? data : []);
    return data;
  }
}
